function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg123Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.57,
    height: 23.873,
    viewBox: "0 0 8.57 23.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7994"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 -.598 4.883)",
    style: {
      fill: "none",
      stroke: "#ffa539",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h17.393"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 14",
    d: "M3.827 1.047a.5.5 0 0 1 .916 0l3.52 8.047a.5.5 0 0 1-.458.7H.765a.5.5 0 0 1-.458-.7z",
    style: {
      fill: "#ffa539"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg123Icon);
export default __webpack_public_path__ + "static/media/123Icon.693a54130dc2644b42c716a3a832bb2e.svg";
export { ForwardRef as ReactComponent };